import last from 'lodash/last';

export const shareInfo = () => {
  const shareShopUrl = typeof window !== 'undefined' ? window.location.href : '';
  const adId = last(shareShopUrl ? shareShopUrl.split('/') : []);
  const mailTo = {
    message: shareShopUrl,
    subject: `Anuncio ${adId}`,
  };

  const sharedToWhatsApp = {
    message: shareShopUrl,
  };

  return {
    link: shareShopUrl,
    mailTo,
    sharedToWhatsApp,
  };
};
